import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { SettingsService } from '@delon/theme';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-upgrade-plan',
  templateUrl: './upgrade-plan.component.html',
  standalone: true,
  imports: [CommonModule, RouterModule, NzIconModule, NzButtonModule]
})
export class UpgradePlanComponent {
  constructor(
    private settings: SettingsService,
    private router: Router
  ) {}

  get isOwner() {
    return this.settings.user['company']?.isOwner;
  }

  upgradePlan() {
    const company = this.settings.user['company'];
    if (!company) return;

    if (!company.isOwner) return;

    this.router.navigate(['./account/subscription'], {
      queryParams: { tid: company.tenantId }
    });
  }
}
